import React, { useState, useEffect } from "react";

import {
  Form,
  Input,
  Button,
  message,
  Alert,
  Row,
  Col,
  Space,
  Radio,
} from "antd";

import { FormOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import Album from "../../component/Album.js";
import Thumb from "../../component/Thumb.js";
import Editor from "../../component/Editor.js";

import styles from "./ProductSave.module.less";

const msg = [
  `系统会自动检测敏感词，若无敏感词，就会直接发布，否则需要人工审核！`,
  `价格、物流费用、计量单位的默认值由您在品牌设置那里填写的默认值生成`,
];

function ProductSave({ navigate, location }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);
  const [status, setStatus] = useState(3);
  const [album, setAlbum] = useState({
    visible: false,
    width: 800,
    limit: 1,
    field: "",
  });

  const [form] = Form.useForm();

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const UnitTips = () => {
    let tips = [...msg];
    if (data?.banMsg) {
      tips.push(data.banMsg);
    }
    if (data?.reviewMsg) {
      tips.push(data.reviewMsg);
    }
    return (
      <div className={styles.tips}>
        <Row>
          <Col offset={4} span={20}>
            <Alert
              showIcon
              icon={<ExclamationCircleOutlined />}
              message={tips.map((v, k) => (
                <div key={k}>
                  {k + 1} . {v}
                </div>
              ))}
              type="warning"
            />
          </Col>
        </Row>
      </div>
    );
  };

  const onUploadOk = (value) => {
    setAlbum({ ...album, visible: false });
    form.setFieldsValue({ thumb: value[0] });
  };

  const onFinish = async (values) => {
    setSubmit(true);
    values = { ...data, ...values };
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`product/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
      setStatus(data.status);
    }
  }, [data]);

  return (
    <div className={styles.ProductSave}>
      <div className={styles.header}>
        <FormOutlined style={{ fontSize: 16, color: "#1890ff" }} />
        <i>{data ? "产品编辑" : "新增产品"}</i>
      </div>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <UnitTips />
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              name="name"
              label="名称"
              rules={[{ required: true, message: "请输入名称!" }]}
            >
              <Input placeholder="请输入名称" />
            </Form.Item>
            <Form.Item
              label="价格"
              name="price"
              rules={[{ required: true, message: "请输入价格" }]}
            >
              <Input suffix="￥" type="number" />
            </Form.Item>
            <Form.Item
              label="物流费用"
              name="express"
              rules={[{ required: true, message: "请输入物流费用" }]}
            >
              <Input placeholder="提示：例如包邮、上门自提、货到付款或面议..." />
            </Form.Item>
            <Form.Item
              label="计量单位"
              name="unit"
              rules={[{ required: true, message: "请输入计量单位" }]}
            >
              <Input placeholder="提示：例如个、套、件或吨..." />
            </Form.Item>
            <Form.Item
              label="关键词"
              name="keyword"
              rules={[{ required: true, message: "请输入关键词" }]}
            >
              <Input placeholder="请输入关键词" />
            </Form.Item>
            <Form.Item
              label="简介"
              rules={[{ required: true, message: "请输入简介" }]}
              name="description"
            >
              <Input.TextArea placeholder="简介" rows={3} />
            </Form.Item>
            <Form.Item
              label="内容"
              rules={[{ required: true, message: "请输入内容" }]}
              name="content"
            >
              <Editor />
            </Form.Item>
            <Form.Item
              label="缩略图"
              name="thumb"
              rules={[{ required: true, message: "请输入缩略图" }]}
            >
              <Thumb
                onClick={() =>
                  setAlbum({
                    visible: true,
                    width: 800,
                    limit: 1,
                    field: "thumb",
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="审核"
              name="status"
              rules={[{ required: true, message: "请选择状态" }]}
            >
              <Radio.Group
                onChange={(e) => {
                  form.setFieldsValue({ reviewMsg: null });
                  setStatus(e.target.value);
                }}
              >
                <Radio value={0}>驳回</Radio>
                <Radio value={3}>通过</Radio>
              </Radio.Group>
            </Form.Item>
            {status !== 0 ? null : (
              <Form.Item
                label="原因"
                rules={[{ required: true, message: "请输入驳回原因" }]}
                name="reviewMsg"
              >
                <Input.TextArea placeholder="请输入驳回原因" rows={3} />
              </Form.Item>
            )}
            <Form.Item wrapperCol={{ offset: 4 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
      <Album
        visible={album.visible}
        width={album.width}
        limit={album.limit}
        brand={data?.brandId}
        onOk={onUploadOk}
        onCancel={() => setAlbum({ ...album, visible: false })}
      />
    </div>
  );
}

export default ProductSave;
